import { useCallback, useEffect } from 'react'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'

import { Box, Button, Typography } from '@material-ui/core'
import FolderOpenIcon from '@material-ui/icons/FolderOpen'

///// Component
const NoProjectWidget: React.FC = () => {
  const { goToTab } = useTabNavigation('/account')
  const goToProjectsList = useCallback(() => {
    goToTab('projects')
  }, [goToTab])
  useEffect(() => goToTab('projects'), [])
  return (
    <Box style={{ marginTop: '2rem' }}>
      <Typography variant='h4'>Project</Typography>
      <Typography>No active project.</Typography>
      <Button
        variant='outlined'
        color='primary'
        endIcon={<FolderOpenIcon />}
        onClick={goToProjectsList}
      >
        Your projects
      </Button>
    </Box>
  )
}

export default NoProjectWidget
